import HTML from "../assets/img/html.svg";
import CSS from "../assets/img/css.svg";
import Tailwind from "../assets/img/tailwind-css.svg";
import Bootstrap from "../assets/img/bootstrap.svg";
import GitHub from "../assets/img/github.svg";
import JavaScript from "../assets/img/javascript.svg";
import ReactJs from "../assets/img/reactjs.svg";
import NextJs from "../assets/img/nextjs.svg";
import ThreeJs from "../assets/img/threejs.svg";
import Flutter from "../assets/img/flutter.svg";
import Java from "../assets/img/java.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { Container, Row, Col } from "react-bootstrap";
import headerImg from "../assets/img/astronaut-lifting-ufo-barbell.svg";
import TrackVisibility from 'react-on-screen';


export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  return (
    <section className="skill" id="skills">
        <Container >
        <Row className="skill-container align-items-center">
          <Col xs={11} md={6} xl={7} >
                    <div className="skill-bx">
                        <h2>Skills</h2>
  
                        <Carousel 
                        responsive={responsive} 
                        autoPlay
                        infinite={true} 
                        arrows={true}
                        className="skill-slider">
                            <div className="item">
                                <img src={HTML} alt="html" />
                                <h5>HTML</h5>
                            </div>
                            
                            <div className="item">
                                <img src={CSS} alt="css" />
                                <h5>CSS</h5>
                            </div>
                            <div className="item">
                                <img src={Tailwind} alt="tailwind" />
                                <h5>Tailwind Css </h5>
                            </div>
                            <div className="item">
                                <img src={Bootstrap} alt="bootstrap" />
                                <h5>Bootstrap</h5>                              
                            </div>
                            <div className="item">
                                <img src={GitHub} alt="github" />
                                <h5>GitHub</h5>                              
                            </div>
                            <div className="item">
                                <img src={JavaScript} alt="js" />
                                <h5>JavaScript</h5>
                            </div>
                            <div className="item">
                                <img src={ReactJs} alt="reactjs" />
                                <h5>ReactJs</h5>                                
                            </div>
                            <div className="item">
                                <img src={NextJs} alt="nextjs" />
                                <h5>NextJs</h5>                                
                            </div>
                            <div className="item">
                                <img src={ThreeJs} alt="threejs" />
                                <h5>ThreeJs</h5>                                
                            </div>
                            <div className="item">
                                <img src={Flutter} alt="flutter" />
                                <h5>Flutter</h5>                                
                            </div>
                            <div className="item">
                                <img src={Java} alt="java" />
                                <h5>Java</h5>                                
                            </div>
                        </Carousel>
            </div>
          </Col>
          <Col xs={11} md={5} xl={5}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__zoomIn" : ""}>
                  <img src={headerImg} alt="Header Img"/>
                </div>}
            </TrackVisibility>
          </Col>
    
        </Row>
      </Container>
    </section>
  )
}